// extracted by mini-css-extract-plugin
export default {"placeholder":"styles_placeholder__hqkho"};